"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethodsToJSON = exports.PaymentMethodsFromJSONTyped = exports.PaymentMethodsFromJSON = exports.PaymentMethods = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var PaymentMethods;
(function (PaymentMethods) {
    PaymentMethods["TOKEN"] = "TOKEN";
    PaymentMethods["CREDIT"] = "CREDIT";
    PaymentMethods["SPLIT"] = "SPLIT";
    PaymentMethods["COINBASE"] = "COINBASE";
    PaymentMethods["NONE"] = "NONE";
})(PaymentMethods = exports.PaymentMethods || (exports.PaymentMethods = {}));
function PaymentMethodsFromJSON(json) {
    return PaymentMethodsFromJSONTyped(json, false);
}
exports.PaymentMethodsFromJSON = PaymentMethodsFromJSON;
function PaymentMethodsFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.PaymentMethodsFromJSONTyped = PaymentMethodsFromJSONTyped;
function PaymentMethodsToJSON(value) {
    return value;
}
exports.PaymentMethodsToJSON = PaymentMethodsToJSON;
